const {CordovaNativeBridge} = require("./bridges/CordovaNativeBridge");
const {WebkitSharedNativeBridge} = require("./bridges/WebkitSharedNativeBridge");

/**
 * The contract of a native bridge function
 */
class NativeBridge {

	constructor(){}

	/**
	 * Invoke the native method with the given arguments. Arguments should be expcted to be serialized to JSON
	 * @param {string} method
	 * @param {Object} args
	 * @return {Promise<unknown>}
	 */
	invokeNativeMethod(method, args) {
		throw new Error('NativeBridge not active');
	}
}

/**
 * Gets the available native bridge class
 * @return {NativeBridge|null}
 */
function getAvailableNativeBridgeClass() {
	if(CordovaNativeBridge.supported()) {
		// @ts-ignore
		return CordovaNativeBridge;
	} else if(WebkitSharedNativeBridge.supported()) {
		// @ts-ignore
		return WebkitSharedNativeBridge;
	}

	return null;
}


let cachedStatusResponse = null;
/**
 * @type {NativeBridge|null}
 */
let existingBridge = null;

/**
 *
 * @return {NativeBridge}
 */
function getBridge() {
	if(!existingBridge) {
		const BridgeClass = getAvailableNativeBridgeClass();
		if (!BridgeClass) {
			throw new Error('No native bridge available');
		}
		// @ts-ignore
		existingBridge = new BridgeClass();
	}
	return existingBridge;
}

const libFableService = require('fable-serviceproviderbase');

class NativeBridgeFableService extends libFableService
{
	constructor(pFable, pOptions, pServiceHash)
	{
		super(pFable, pOptions, pServiceHash);

		/**
		 * @type {import('fable') & { ContentAssignment: import('pict/types/source/Pict-Content-Assignment') }}}
		 */
		this.fable;

		this.serviceType = 'NativeBridge';

	}

	/**
	 * Checks if native functions are available.
	 *
	 * @return {*|boolean}
	 */
	hasNativeSupport() {
		return getAvailableNativeBridgeClass() !== null;
	}

	/**
	 * Prints image
	 * @param {object} options
	 * @param {string} [options.jobName] - Title of the print job
	 * @param {string} options.base64Image - Base64 encoded image
	 * @return {Promise}
	 */
	async printImage(options) {
		const supported = await this.methodSupported('printImage');
		if(!supported) {
			window.alert('This app version does not support printing. Please update your application to the latest version.');
			return Promise.reject('Native print not supported');
		}
		return await getBridge().invokeNativeMethod('printImage', {
			jobName: options.jobName || 'Print Image',
			base64Image: options.base64Image,
		});
	}

	/**
	 * Gets the location coordinates from a native app.
	 * @return {Promise}
	 */
    async getLocation() {
		const supported = await this.methodSupported('getLocation');
		if(!supported) {
			return Promise.reject('Native location not supported');
		}
	   return await getBridge().invokeNativeMethod('getLocation', {});
    }

	/**
	 * Gets the bridge status details, once fetched they will not be fetched again.
	 * This gives you version numbers and other details about the native bridge.
	 *
	 * If the bridge doesn't exist then you get bridgeVersion: 0 and appVersion: ''
	 *
	 * @return {Promise<{
	 *     bridgeVersion: number,
	 *     appVersion: string,
	 * 	   supports: array,
	 *     intent?: {
	 *         action: string,
	 *         data: string,
	 *     }
	 * }>}
	 */
	async status() {
		if(getAvailableNativeBridgeClass() == null) {
			return {
				bridgeVersion: 0,
				appVersion: '',
				supports: ['status', 'hasNativeSupport']
			}
		}

		if(!cachedStatusResponse) {
			cachedStatusResponse = await getBridge().invokeNativeMethod('status', {});
		}

		cachedStatusResponse.supports = ['status', 'hasNativeSupport'];

		if (cachedStatusResponse.bridgeVersion >= 1)
		{
			cachedStatusResponse.supports.push('printImage');
		}
		if (cachedStatusResponse.bridgeVersion >= 2)
		{
			cachedStatusResponse.supports.push('getLocation');
		}

		return cachedStatusResponse;
	}

	/**
	 * Method to check if a method is supported by the native bridge.
	 * @param {String} method - name of the method we are checking support for. 
	 */
	async methodSupported(method)
	{
		const status = await this.status();
		return status.supports.includes(method);
	}
}

module.exports = NativeBridgeFableService;
module.exports.default_configuration = {};